module.exports = "/static/images/silva.png";